export class PolizaCreacion {
    /**Datos de póliza */
    t1: DatosPoliza = new DatosPoliza();
    /**Datos de recibos */
    t2: Array<DatosRecibos> = [];
    /**Datos de grupos */
    t3: Array<DatosGrupos> = [];
    /**Datos de comisión */
    t4: DatosComision = new DatosComision();
    /**Datos de vehiculo */
    t5: DatosVehiculoPoliza = new DatosVehiculoPoliza();
    /**Datos de cotización */
    t6: DatosCotizacionPoliza = new DatosCotizacionPoliza();
    /**Url de pólizas */
    t7: string = '';
}

export class DatosPoliza {
    /**CotizacionId */
    cotId: number = 0;
    /**EmisionId */
    emiId: number = 0;
    /**ColectividadId encriptado */
    //colId?: string = '';
    /**NegocioId */
    negId: number = 0;
    /**AseguradoraId */
    cia: number = 0;
    /**RamoId */
    ram: number = 0;
    /**Subramo */
    sbr: number = 0;
    /**ClienteId */
    cli: number = 0;
    /**DireccionClienteId */
    dcl: number = 0;
    /**AgenteClaveId */
    agc: number = 0;
    /**MonedaId */
    mon: number = 0;
    /**FormaPagoid */
    fpa: number = 0;
    /**FormaCobroid */
    fco: number = 0;
    /**NoPoliza aseguradora */
    npo: string = '';
    /**Inciso */
    inc: number = 0;
    /**Concepto de póliza */
    con: string = '';
    /**Referecia póliza */
    ref: string = '';
    /**PrimaNeta póliza */
    pri: number = 0.00;
    /**Ajuste1 de póliza */
    aj1: number = 0.00;
    /**Ajuste2 de póliza */
    aj2: number = 0.00;
    /**CargoExtra de póliza */
    cxt: number = 0.00;
    /**Derecho de póliza */
    der: number = 0.00;
    /**Recargo de póliza */
    rcg: number = 0.00;
    /**IVA de póliza */
    iva: number = 0.00;
    /**PrimaTotal de póliza */
    tot: number = 0.00;
    /**ExtraAfectaIva */
    xai: boolean = false;
    /**ExtraProrratea */
    xpr: boolean = false;
    /**DerechoProrratea */
    dpr: boolean = false;
    /**RecargoProrratea */
    rpr: boolean = false;
    /**Fecha emisión */
    fem: string = '';
    /**VigeciaDe */
    fvd: string = '';
    /**VigenciaA */
    fva: string = '';
    /**FechaCreación */
    fcr: string = '';
    /**VendedorId */
    vnd: number = 0;
    /**Status */
    status: number = 3;
    /**Codigo de promocion*/
    cod_promocion: string = '';
}

export class DatosRecibos {
    /**Serie Recibo */
    ser: number = 0;
    /**TotalSerie recibos */
    tse: number = 0;
    /**PrimaNeta recibo */
    pri: number = 0.00;
    /**Ajuste1 recibo */
    aj1: number = 0.00;
    /**Ajuste2 recibo */
    aj2: number = 0.00;
    /**CargoExtra recibo */
    cxt: number = 0.00;
    /**Derecho recibo */
    der: number = 0.00;
    /**RecargoRecibo */
    rcg: number = 0.00;
    /**IVA recibo */
    iva: number = 0.00;
    /**PrimaTotal recibo */
    tot: number = 0.00;
    /**Comisión recibo */
    com: number = 0.00;
    /**VigeciaDe */
    fvd: string = '';
    /**VigenciaA */
    fva: string = '';
    /**FehaVence */
    fvn: string = '';// fecha vence
    /**FechaCracion */
    fcr: string = '';// fecha creacion
    /**referencia de la compañia */
    ref?:string;
}

export class DatosGrupos {
    /**GrupoId */
    gpo: number = 0;
    /**principal */
    pal: boolean = false;
}

export class DatosComision {
    /**Prima comisión */
    pri: number = 0.00;
    /**Derecho comisión */
    der: number = 0.00;
    /**Recargo comisión */
    rcg: number = 0.00;
    /**Promotor comisión */
    pro: number = 0.00;
    /**Sobre1 comisión */
    so1: number = 0.00;
    /**Sobre2 comisión */
    so2: number = 0.00;
}

export class DatosVehiculoPoliza {
    /**NoSerie */
    nse: string = '';
    /**ClaveAmis */
    ami: string = '';;
    /**Descripción vehículo */
    dsc: string = '';
    /**Tipo vehículo FOCUS. ETC.. */
    tip: string = '';
    /**Modelo */
    mdl: number = 0;
    /**Motor */
    mtr: string = '';
    /**Nombre conductor */
    nmb: string = '';//nombres
    /**Apellido paterno conductor */
    app: string = '';
    /**Apellido materno conductor */
    apm: string = '';
    /**sexo */
    sex: boolean = false;//sexo
    /**Fecha nacimiento conductor */
    fnc: string = '';
    /**Correo contratante */
    crr: string = '';
    /**Celular contratante */
    cel: string = '';
    /**RFC contratante */
    rfc: string = '';
    /**CURP */
    crp: string = '';
    /**IMSS */
    ims: string = '';
    /**Dirección contratante */
    dir: string = '';
    /**Codigo postal contratante */
    cpi: string = '';
    /**Colonia contratante */
    col: string = '';
    /**MunicipioId */
    mun: number = 0;
    /**Edad */
    eda: number = 0;
    /**Nómina */
    nom: string = ''
    /**Placa vehículo */
    plc: string = '';
    /**EstadoId de circulación */
    edo: number = 0;
    /**Uso */
    uso: string = '';
    servicio: string = '';
}

export class DatosCotizacionPoliza {
    /**RamoId datosQuattro*/
    ramoId: string = '';
    /**AseguradoraId datosQuattro */
    aseguradoraId: string = '';
    /**PaqueteId datosQuattro*/
    paqueteId: string = '';
    /**PaqueteId */
    paqId: string = '';
    /**Paquete nombre */
    paqNom: string = '';
    /**Coberturas array */
    coberturas: Array<CoberturasPoliza> = [];
}

export class CoberturasPoliza {
    /**Cobertura clave */
    cob: string = '';
    /**Deduclible cobertura */
    ded: string = '';
    /**Deducible descripción */
    dedDesc?: string = '';
    /**Descripción cobertura */
    descr: string = '';
    /**Icono Cobertura */
    ico?: number = 0;
    /**Prima cobertura */
    pri: number = 0.00;
    /**Valor Cobertura */
    val: string = '';
    /**Valor descripción */
    valDesc?: string = '';
}

